export const DEFAULT_CIRCLE_IMAGE = "/favicon-512.png";
export const DEFAULT_PROFILE_IMAGE = "/blank-profile-picture.png";
